let checkIntervalForm;

function setListeners() {
    // Check if the element exists
    clearInterval(checkIntervalForm)

    if(document.querySelectorAll('.tribe-tickets__form.tribe-tickets__attendee-tickets-item').length > 0) {

        // We need hide the elements .tribe-tickets__attendee-tickets-item except the first one
        let items = document.querySelectorAll('.tribe-tickets__form.tribe-tickets__attendee-tickets-item');
        items.forEach((item, index) => {
            if(index > 0) {
                item.style.display = 'none';
            }
        });



        let fieldsNum = document.querySelectorAll(".tribe-tickets__form.tribe-tickets__attendee-tickets-item").length;

        if(document.querySelectorAll('#tribe-tickets_32_nombre-completo_1').length > 0) {
            let nombre = document.getElementById('tribe-tickets_32_nombre-completo_1');
            let correo = document.getElementById('tribe-tickets_32_correo-electronico_1');
            let celular = document.getElementById('tribe-tickets_32_celular_1');
            let edad = document.getElementById('tribe-tickets_32_edad_1');
            let referido = document.getElementById('tribe-tickets_32_referido-de_1');

            nombre.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_32_nombre-completo_' + i)) {
                        document.querySelector('#tribe-tickets_32_nombre-completo_' + i).value = nombre.value;
                    }
                }
            });

            correo.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_32_correo-electronico_' + i)) {
                        document.querySelector('#tribe-tickets_32_correo-electronico_' + i).value = correo.value;
                    }
                }
            });

            celular.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_32_celular_' + i)) {
                        document.querySelector('#tribe-tickets_32_celular_' + i).value = celular.value;
                    }
                }
            });

            edad.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_32_edad_' + i)) {
                        document.querySelector('#tribe-tickets_32_edad_' + i).value = edad.value;
                    }
                }
            });

            referido.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_32_referido-de_' + i)) {
                        document.querySelector('#tribe-tickets_32_referido-de_' + i).value = referido.value;
                    }
                }
            });
        }

        if(document.querySelectorAll('#tribe-tickets_125_nombre-completo_1').length > 0) {
            let nombre = document.getElementById('tribe-tickets_125_nombre-completo_1');
            let correo = document.getElementById('tribe-tickets_125_correo-electronico_1');

            nombre.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_125_nombre-completo_' + i)) {
                        document.querySelector('#tribe-tickets_125_nombre-completo_' + i).value = nombre.value;
                    }
                }
            });

            correo.addEventListener('change', function() {
                for(let i = 2; i <= fieldsNum; i++) {
                    if(document.querySelector('#tribe-tickets_125_correo-electronico_' + i)) {
                        document.querySelector('#tribe-tickets_125_correo-electronico_' + i).value = correo.value;
                    }
                }
            });

        }

    }
}


//document.addEventListener('DOMContentLoaded', () => {
//    checkIntervalForm = setInterval(() => {
//        if(document.querySelectorAll('.tribe-tickets__form.tribe-tickets__attendee-tickets-item').length) {
//            setListeners();
//        }
//    }, 500);
//});

document.addEventListener('DOMContentLoaded', () => {
    checkIntervalForm = setInterval(() => {
        if(document.querySelector('.tribe-tickets__registration-event')) {
            if(document.querySelector('.tribe-tickets__registration-event').getAttribute('data-event-id') == 3413) {
                document.querySelector('body').classList.add('page-template-interna-indexvii');
            }
        }
    }, 500);
});


// Prepare countdown
function prepareCountdown() {
    const countdownEl = document.querySelector('.countdown');
    if (!countdownEl) return;

    // Set the date we're counting down to
    const targetDate = new Date("April 17, 2026 19:00:00").getTime();

    const daysEl = countdownEl.querySelector('.days .number');
    const hoursEl = countdownEl.querySelector('.hours .number');
    const minutesEl = countdownEl.querySelector('.minutes .number');
    const secondsEl = countdownEl.querySelector('.seconds .number');

    if (!daysEl || !hoursEl || !minutesEl || !secondsEl) return;

    // Update the countdown every 1 second
    const interval = setInterval(function() {
        const now = new Date().getTime();
        const distance = targetDate - now;

        if (distance < 0) {
            clearInterval(interval);
            daysEl.innerHTML = "00";
            hoursEl.innerHTML = "00";
            minutesEl.innerHTML = "00";
            secondsEl.innerHTML = "00";
            return;
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        daysEl.innerHTML = days < 10 ? "0" + days : days;
        hoursEl.innerHTML = hours < 10 ? "0" + hours : hours;
        minutesEl.innerHTML = minutes < 10 ? "0" + minutes : minutes;
        secondsEl.innerHTML = seconds < 10 ? "0" + seconds : seconds;
    }, 1000);
}

document.addEventListener('DOMContentLoaded', () => {
    prepareCountdown();
});


